import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Typography, Paper, Box, Button } from "@mui/material";
import W1 from "../../images/wallet1.png";
import W2 from "../../images/wallet2.png";
import W3 from "../../images/wallet3.png";
import W4 from "../../images/wallet4.png";
import WalletComp from "./walletComp";
export default function WalletRow() {
  return (
    <>
      <Grid
        container
        sx={{
          margin: "30px 24px ",
          width: "auto!important",
        }}
      >
        <Grid item xs={12} md={6} lg={3}>
          <WalletComp head="Ethereum" img={W1} />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box sx={{filter:"blur(2px)"}}><WalletComp head="BitCoin" img={W2} /></Box>
          
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box sx={{filter:"blur(2px)"}}>
          <WalletComp head="USDT" img={W3} />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Box sx={{filter:"blur(2px)"}}>
          <WalletComp head="BNB" img={W4} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
